'use strict';
const _ = require('underscore');
const Backbone = require('backbone');
const Moment = require('moment');
const Util = require('common/util');
const Action = require('process/domain/entity/action/index');
const Decision = require('process/domain/entity/action/decision');
const ActionTypeRepository = require('process/domain/repository/action/type');
const GroupRepository = require('common/domain/repository/group');
const GroupAction = require('common/domain/action/group');

class Factory {
    constructor(project) {
        this._project = project;
    }

    build(json, repository, isHistory, appendChild = true) {
        return new Promise((resolve, reject) => {
            if(!json.id) {
                json.id = Util.generateId();
            }
            json._project = this._project;
            json._repository = repository;

            if(json.endAt) {
                json.endAt = Moment(json.endAt);
            }
            if(json.startAt) {
                json.startAt = Moment(json.startAt);
            }

            let p;
            if(json.type == 'decision') {
                p = new Decision(json);
            }
            else {
                p = new Action(json);
            }

            const parentPromise = json.parent ? repository.fetchActionNoRaise(json.parent) : null;
            const group = GroupRepository.getGroups().get(p.getProject().getGroupId());

            Promise.all([
                ActionTypeRepository.find(this._project).get(json.type),
                parentPromise,
                group ? null : GroupAction.fetchGroupOnce(p.getProject().getGroupId())
            ]).then((values) => {
                try {
                    const actionType = values[0];
                    const parent = values[1];
                    p.set({_type: actionType});

                    const group = GroupRepository.getGroups().get(p.getProject().getGroupId());
                    const members = group.getMembers({withSuspended: true});
                    if(json.assignees) {
                        const assignedUsers = _.map(json.assignees, a => {
                            const m = members.getMemberByUser(a);
                            return m.getUser();
                        });
                        p.setAssignees(
                            _.sortBy(assignedUsers, a => {
                                return a.getName().toLowerCase();
                            })
                        );
                    }
                    if(json.updatedBy) {
                        const m = members.getMemberByUser(json.updatedBy);
                        p.setUpdatedBy(m);
                    }
                    if(parent && !isHistory && appendChild) {
                        parent.addChild(p);
                        p.set('parent', parent);
                    }

                    resolve(p);
                } catch(e) {
                    reject(e);
                }
            }, reject);
        });
    }
}

module.exports = Factory;



// WEBPACK FOOTER //
// ./process/domain/factory/action/index.js